import { useEffect, useState } from "react";
import timeingStuff from "@serie3/freelancesplaceapi/Domain/Shared/timeingStuff";
import { faCalendarDay, faClock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

const TodoRow = ({ todo, deleteFunction, dailyList = false, markAsDaily }) => {
  const [ageInDays, setAgeInDays] = useState(0);

  useEffect(() => {
    setAgeInDays(timeingStuff.calculateAge(todo.date));
  }, [todo]);

  const moveDailyTip = (
    <Tooltip id="movedaily">
      <small>Move to daily list</small>
    </Tooltip>
  );

  return todo ? (
    <li style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "10px 14px",
      borderRadius: "8px",
      marginBottom: "6px",
      background: "#fff",
      boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
      listStyle: "none",
    }}>
      <input
        type="checkbox"
        onClick={deleteFunction}
        style={{
          width: "18px",
          height: "18px",
          accentColor: "#1a73e8",
          cursor: "pointer",
          flexShrink: 0,
        }}
      />
      <span style={{ flex: 1, fontSize: "0.92rem", color: "#212121" }}>
        {todo.value}
      </span>
      {ageInDays > 0 && (
        <span style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "4px",
          background: "#ffebee",
          color: "#c62828",
          fontSize: "0.72rem",
          fontWeight: 600,
          padding: "2px 8px",
          borderRadius: "20px",
          flexShrink: 0,
        }}>
          <FontAwesomeIcon icon={faClock} />
          {ageInDays}d
        </span>
      )}
      {!dailyList && typeof markAsDaily === "function" ? (
        <OverlayTrigger overlay={moveDailyTip}>
          <a
            href="#"
            onClick={markAsDaily}
            style={{ color: "#9e9e9e", flexShrink: 0, fontSize: "0.9rem" }}
          >
            <FontAwesomeIcon icon={faCalendarDay} />
          </a>
        </OverlayTrigger>
      ) : null}
    </li>
  ) : null;
};

export default TodoRow;
